export default { Alpha: () => <p>Alpha</p> }